// Side-effect import movido a src/init/sessionResetRegistrations.ts (cargado en App.tsx).
// Antes acá: import './infra/sessionResetRegistration' — forzaba evaluación sincrónica
// del barrel y convertía require cycles en crashes de runtime.

export { useEmployeesStore, withSelfOwner } from './store/useEmployeesStore';
export type { EmployeeRecord } from './store/useEmployeesStore';
export { EmployeePermissionsScreen } from './screens/admin/EmployeePermissionsScreen';
export { TeamHubScreen } from './screens/TeamHubScreen';
export { InviteEmployeeScreen } from './screens/admin/InviteEmployeeScreen';
export { TeamHistoryScreen } from './screens/TeamHistoryScreen';

// Auto-added missing exports
export type { EmployeePermission } from './store/useEmployeesStore';

// Auto-added missing exports (smart)
export { PermissionLevel, permissionLevelFromTriple } from './store/useEmployeesStore';
export { InvitationListItem, inviteEmployee } from './application/employeeInvitations';

// Auto-added missing exports (smart)
export { insertEmployeeBranchWithDefaults, revokeEmployeeBranchAccess, revokeEmployeeAccess, reactivateEmployeeAccess, applyPermissionPreset } from './application/employeesApi';
export { fetchMyInvitations } from './application/employeeInvitations';
